/* Imports */
import { defineStore } from 'pinia';

export const useFlashMessagesStore = defineStore('flashMessages', {
  state: () => ({
    flashMessages: [],
  }),
  getters: {
    getFlashMessages: (state) => state.flashMessages,
  },
  actions: {
    setFlashMessage(payload) {
      // Check the GC Alert to see what values can be passed to its props.
      const msg = {
        type: payload?.type,
        text: payload?.text,
        closeable: payload?.closeable,
        onClose: payload?.onClose,
        align: payload?.align,
        leftIcon: payload?.leftIcon,
        testId: payload?.testId,
      };

      this.flashMessages.push(msg);
    },
    removeFlashMessage(index) {
      this.flashMessages = this.flashMessages.filter((msg, i) => i !== index);
    },
    removeAllFlashMessages() {
      this.flashMessages = [];
    },
  },
});

export default useFlashMessagesStore;
